import { render, staticRenderFns } from "./DataTagging.vue?vue&type=template&id=9c564b78&scoped=true"
import script from "./DataTagging.vue?vue&type=script&lang=ts"
export * from "./DataTagging.vue?vue&type=script&lang=ts"
import style0 from "./DataTagging.vue?vue&type=style&index=0&id=9c564b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c564b78",
  null
  
)

export default component.exports